import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M5 7.80775V19H19V7.80775H15V14.5963L12 13.0963L9 14.5963V7.80775H5ZM4 20V6.9155L6.4155 4H17.5655L20 6.95375V20H4ZM5.38075 6.80775H18.6L17.077 5H6.90375L5.38075 6.80775ZM10 7.80775V12.9615L12 11.9615L14 12.9615V7.80775H10Z",
      fill: "black"
    }, null, -1)
  ])))
}
export default { render: render }